/**
 * @generated SignedSource<<142dc2232f839fc238ecbb16d42f1686>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationsEnum = "BIGQUERY" | "HUBSPOT" | "MARKETO" | "ZOHO";
export type Integration_Manager_Query$variables = Record<PropertyKey, never>;
export type Integration_Manager_Query$data = {
  readonly integrationsManager: {
    readonly activeIntegrations: ReadonlyArray<IntegrationsEnum | null | undefined> | null | undefined;
  } | null | undefined;
};
export type Integration_Manager_Query = {
  response: Integration_Manager_Query$data;
  variables: Integration_Manager_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "IntegrationsManager",
    "kind": "LinkedField",
    "name": "integrationsManager",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "activeIntegrations",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "Integration_Manager_Query",
    "selections": (v0/*: any*/),
    "type": "RootQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "Integration_Manager_Query",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c5563d4bbfd384819c3908bce9a40f68",
    "id": null,
    "metadata": {},
    "name": "Integration_Manager_Query",
    "operationKind": "query",
    "text": "query Integration_Manager_Query {\n  integrationsManager {\n    activeIntegrations\n  }\n}\n"
  }
};
})();

(node as any).hash = "cc7706b8ba00b2ffff71c13977b516c9";

export default node;
